export {
	SvelteComponentDev as SvelteComponent,
	onMount,
	onDestroy,
	beforeUpdate,
	afterUpdate,
	setContext,
	getContext,
	getAllContexts,
	hasContext,
	tick,
	createEventDispatcher,
	SvelteComponentTyped
} from './internal/index.js';
